<template>
  <div
    class="dj-product-container flex-wrap sm:flex-nowrap"
    :class="{ active: open }"
    @click="goToProduct"
  >
    <DjImage
      :src="mainPictureUrl || ''"
      :width="100"
      :height="100"
      :alt="productName"
      class="dj-product-image w-12 h-12 sm:w-16 sm:h-16"
    />
    <div class="dj-product-details flex-1 pl-4 border-l-4 border-green-700 w-full">
      <UTooltip :text="productName" :delay-duration="tooltipDelay">
        <p
          class="text-black text-base flex items-start justify-start font-bold"
          :class="{
            'max-w-[180px]': small,
            'dj-product-name-ellipsis': !small,
          }"
        >
          <span class="md:truncate text-left">{{ productName }}</span>
        </p>
      </UTooltip>
      <div class="text-sm">
        <span class="text-gray-400">Ref Adisco:</span>
        <span class="text-gray-900 font-semibold">{{ getProductReference }}</span>
      </div>
      <div class="text-sm">
        <span class="text-gray-400">Fournisseur:</span>
        <span class="text-gray-900 font-semibold">{{ getProductBrand }}</span>
      </div>
    </div>
    <UButton
      v-if="isAuthenticated && hasVariants"
      :icon="`djust-icon:${open || isOver ? 'open-white' : 'open'}`"
      size="sm"
      class="dj-product-action"
      :class="{ active: open }"
      @click.stop="selectProduct"
      @mouseover="isOver = true"
      @mouseout="isOver = false"
    />
  </div>
</template>

<script setup lang="ts">
  import { useSearchProduct } from '@/composables/useSearchProduct';

  const props = defineProps<{
    product: ProductSearchContent;
    open: boolean;
    small: boolean;
    hasVariants: boolean;
  }>();

  const router = useRouter();
  const { getAttributeValuesByExternalId, getProductVariantName, getMainPictureUrl } =
    useSearchProduct();
  const useStore = useUserStore();

  const isAuthenticated = computed(() => useStore.isAuthenticated);
  const isOver = ref(false);

  // Computed product name
  const productName = computed(() => getProductVariantName(props.product));

  // Computed product main picture url
  const mainPictureUrl = computed(() => getMainPictureUrl(props.product));

  const nb_variants = computed(() => getAttributeValuesByExternalId(props.product, 'nb_variants'));

  const getProductReference = computed(() => {
    return props.product.variant?.externalId;
  });
  const getProductBrand = computed(() => {
    return props.product.product?.brand;
  });
  const localePath = useLocalePath();

  const emit = defineEmits<{
    'select-product': [product: ProductSearchContent]; // named tuple syntax
    'go-to-product': any;
  }>();

  const selectProduct = () => {
    emit('select-product', props.product);
  };

  const goToProduct = () => {
    emit('go-to-product');
    router.push(localePath(`/product/${props.product.product.sku}`));
  };
</script>

<style lang="scss" scoped>
  @use './DjProductSearchResult.scss';
</style>
